import { useState, useEffect, useContext } from "react";
import { Link, useParams } from 'react-router-dom';

import Loading from "../../components/Loading";

import Data from '../../../repository';
import AppContext from '../../../context';

import styles from '../../../styles/Admin.module.scss';

const formatMoney = (amount) => `£${(Number(amount || 0) / 100).toFixed(2)}`;

const TX_TYPE_LABELS = {
	purchase: 'Top Up',
	spend: 'Spend',
	refund: 'Refund',
	adjustment: 'Adjustment',
	membership_grant: 'Membership Grant',
};

function formatDate(date) {
	if (!date) return '—';
	return new Date(date).toLocaleString('en-GB', {
		day: '2-digit', month: 'short', year: 'numeric',
		hour: '2-digit', minute: '2-digit'
	});
}

function WalletHistory({ userId }) {
	const [transactions, setTransactions] = useState(null);
	const [loading, setLoading] = useState(false);
	const [loaded, setLoaded] = useState(false);

	const load = async () => {
		setLoading(true);
		try {
			const result = await Data.adminFetchUserWalletTransactions(userId);
			setTransactions(result.data || []);
			setLoaded(true);
		} finally {
			setLoading(false);
		}
	};

	if (!loaded) {
		return (
			<button type="button" className="btn btnEmpty" onClick={load} disabled={loading}>
				{loading ? 'Loading...' : 'View Wallet History'}
			</button>
		);
	}

	if (!transactions.length) return <p>No wallet transactions found.</p>;

	return (
		<div className={styles.tableWrap}>
			<table className={styles.table}>
				<thead>
					<tr>
						<th>Date</th>
						<th>Type</th>
						<th>Amount</th>
						<th>Status</th>
						<th>Detail</th>
					</tr>
				</thead>
				<tbody>
					{transactions.map((tx) => (
						<tr key={tx._id}>
							<td>{formatDate(tx.createdAt)}</td>
							<td>{TX_TYPE_LABELS[tx.type] || tx.type}</td>
							<td style={{ color: Number(tx.amount) < 0 ? '#c0392b' : 'inherit' }}>
								{Number(tx.amount) >= 0 ? '+' : ''}{formatMoney(tx.amount)}
							</td>
							<td>{tx.status}</td>
							<td>
								{tx.WalletPackage?.name || ''}
								{tx.ExperienceBooking ? 'Class booking' : ''}
								{tx.ServiceBooking ? 'Service booking' : ''}
								{tx.Booking ? 'Session booking' : ''}
								{tx.note ? tx.note : ''}
							</td>
						</tr>
					))}
				</tbody>
			</table>
		</div>
	);
}

function Existing(){
	const { id } = useParams();
	const context = useContext(AppContext);
	const isVariableMode = !['sessions', 'membership', 'experiences', 'hybrid', 'hybrid-new'].includes(context.domain?.businessType);

	const [loading, setLoading] = useState(true);
	const [user, setUser] = useState(null);
	const [activationLoading, setActivationLoading] = useState(false);

	useEffect(async () => {
		await fetchUser();
	}, [])

	const fetchUser = async () => {
		setLoading(true);
		const user = await Data.fetchUserById(id);
		setUser(user.data);
		setLoading(false);
	}

	const toggleActivation = async (active) => {
		setActivationLoading(true);
		try {
			await Data.setUserActivation(user._id, active);
			await fetchUser();
		} catch (error) {
			console.error('Failed to update activation', error);
		} finally {
			setActivationLoading(false);
		}
	}

	if(loading) return <Loading button={false} />

	return (
		<>
			<div className={styles.form}>
				<div>
					<p>First Name:</p>
					<input type="text" value={user.firstName} disabled={true} />
				</div>

				<div>
					<p>Last Name:</p>
					<input type="text" value={user.lastName} disabled={true} />
				</div>

				<div>
					<p>Email Address:</p>
					<input type="text" value={user.email} disabled={true} />
				</div>

				<div>
					<p>Phone Number:</p>
					<input type="text" value={user.phoneNumber} disabled={true} />
				</div>

				<div>
					<p>Verified:</p>
					<input type="text" value={user.emailVerified ? 'Yes' : 'No'} disabled={true} />
				</div>

				{!isVariableMode && (
					<div>
						<p>Admin:</p>
						<input type="text" value={user.admin ? 'Yes' : 'No'} disabled={true} />
					</div>
				)}

				<div>
					<p>Activation Status:</p>
					<input type="text" value={user.isActive ? 'Active' : 'Awaiting activation'} disabled={true} />
				</div>

				{!isVariableMode && (
					<div>
						<p>Balance:</p>
						<input type="text" value={user.balance} disabled={true} />
					</div>
				)}
			</div>

			<div className={styles.actions}>
				{/*<Link to={`/admin/bookings?user=${id}`} className="btn btnEmpty">View Bookings</Link>*/}
				{/*<button className="btn btnEmpty">View Transactions</button>*/}
				{/*<button className="btn btnEmpty">Send Password Reset</button>*/}
				{/*<button className="btn btnDanger">Delete Users</button>*/}
				{!isVariableMode && <Link to={`/admin/transactions/create?user=${user._id}`} className="btn btnEmpty">+ Gift Tokens</Link>}
				{user.isActive ? (
					<button className="btn btnDanger" onClick={() => toggleActivation(false)} disabled={activationLoading}>
						{activationLoading ? 'Updating...' : 'Deactivate User'}
					</button>
				) : (
					<button className="btn btnPrimary" onClick={() => toggleActivation(true)} disabled={activationLoading}>
						{activationLoading ? 'Updating...' : 'Activate User'}
					</button>
				)}
			</div>

			{user.minors.length > 0 &&
				<div className={styles.form}>
					<h3>Minors</h3>
					{user.minors.map((minor) => {
						return <Link to={`/admin/minors/${minor._id}`} className="btn btnEmpty btnLeft">{minor.name}</Link>
					})}
				</div>
			}

			{isVariableMode && (
				<div className={styles.form}>
					<h3>Wallet Transactions</h3>
					<WalletHistory userId={user._id} />
				</div>
			)}
		</>
	)
}

export default Existing;
